module.exports = __webpack_public_path__ + "img/app_nf_1.09d1442d.jpg";